import * as yup from "yup";
import { Values } from "./types";

const { _rlapp_user: { contact = "" } = {} } = window || {};

export const INITIAL_VALUES: Values = {
  type: "false-positive",
  comment: "",
  contact
};

export const VALIDATION_SCHEMA = yup.object<Values>().shape({
  type: yup.string().required("Please select a report type"),
  comment: yup.string().required("Please enter a comment"),
  contact: yup.string().email("Please enter a valid email address")
});
